import { render, staticRenderFns } from "./OwnerSearch.vue?vue&type=template&id=380db7aa&"
import script from "./OwnerSearch.vue?vue&type=script&lang=js&"
export * from "./OwnerSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports